import(/* webpackMode: "eager" */ "/vercel/path0/app/(main)/about/page.tsx");
